'use client';

/* eslint-disable @typescript-eslint/unbound-method */
import { useEffect } from 'react';

/**
 * HashChangeInterceptor
 * - 브라우저의 `history.pushState` 및 `history.replaceState` 메서드를 가로채서
 *   해시(`window.location.hash`)가 변경될 때마다 `custom-hash-change` 이벤트를 트리거합니다.
 * - 전역적인 해시 변경 감지 및 이벤트 처리를 위한 컴포넌트입니다.
 */
export const HashChangeInterceptor = () => {
  useEffect(() => {
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    // 현재 해시 상태를 저장
    let currentHash = window.location.hash;

    /**
     * triggerCustomHashChange
     * - 현재 해시 값과 새로운 해시 값을 비교하여 변경이 있을 경우
     *   `custom-hash-change` 이벤트를 생성하고 트리거합니다.
     */
    const triggerCustomHashChange = () => {
      const newHash = window.location.hash;

      if (currentHash !== newHash) {
        currentHash = newHash; // 새로운 해시 값으로 업데이트
        const event = new CustomEvent('custom-hash-change'); // 커스텀 이벤트 생성
        window.dispatchEvent(event); // 이벤트 트리거
      }
    };

    /**
     * pushState 가로채기
     * - `window.history.pushState`를 확장하여 호출 후 해시 변경 여부를 확인하고
     *   `custom-hash-change` 이벤트를 트리거합니다.
     */
    window.history.pushState = (...args) => {
      originalPushState.apply(window.history, args); // 기본 pushState 동작 수행
      triggerCustomHashChange();
    };

    /**
     * replaceState 가로채기
     * - `window.history.replaceState`를 확장하여 호출 후 해시 변경 여부를 확인하고
     *   `custom-hash-change` 이벤트를 트리거합니다.
     */
    window.history.replaceState = (...args) => {
      originalReplaceState.apply(window.history, args); // 기본 replaceState 동작 수행
      triggerCustomHashChange();
    };

    return () => {
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  return null;
};
